import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ orders }: RootState) => orders;

export const selectOrders = createSelector(
    selectRoot,
    ({ orders }) => orders,
);
